import { AbiItem } from 'web3-utils'
import LSP6KeyManager from '@lukso/lsp-smart-contracts/artifacts/LSP6KeyManager.json'

export const keyManagerABI: AbiItem[] = LSP6KeyManager.abi as AbiItem[]
